import React, {useEffect, useState} from 'react'
import {Notification, Toggle, toaster} from 'rsuite'
import {gql, useMutation} from '@apollo/client'

const MUTATION_SET_ENABLED = gql`
  mutation SetAutoImportEnabled($importer: AutoImporter!, $enabled: Boolean!) {
    extensions {
      setAutoImportEnabled(importer: $importer, enabled: $enabled)
    }
  }
`

type SetEnabledMutationData = {
  extensions: {
    setAutoImportEnabled: boolean
  }
}

// Switches an importer's daily cron job on or off. The value lives on the
// Website content (enableAutoPanelMemberImport / enableAutoFoundationCouncilImport),
// where the cron job reads it.
export function AutoImportToggle({
  importer,
  enabled,
}: {
  importer: 'panelMember' | 'foundationCouncil'
  enabled: boolean | undefined
}) {
  const [checked, setChecked] = useState(enabled)
  const [setEnabled, {loading}] = useMutation<SetEnabledMutationData>(MUTATION_SET_ENABLED)

  useEffect(() => setChecked(enabled), [enabled])

  async function onChange(value: boolean) {
    try {
      const {data} = await setEnabled({variables: {importer, enabled: value}})
      setChecked(data?.extensions.setAutoImportEnabled)
    } catch (error) {
      toaster.push(<Notification closable type="error" header={`${error}`} duration={5000} />, {
        placement: 'topEnd',
      })
    }
  }

  return (
    <Toggle
      checked={checked ?? false}
      disabled={checked === undefined}
      loading={loading}
      onChange={onChange}
      checkedChildren="on"
      unCheckedChildren="off"
    />
  )
}
